<template>
  <CRow style="justify-content: center;">
    <CCol  col="2" >
      <CWidgetDropdown
              style="margin-bottom:0;height:80px;place-items: center;text-align: center;background:#39f"
              class="box_item_center"
              :header="get_currency(sales2)"
              :text="$t('Revenue')">
        <template #default>

        </template>
        <template #footer>

<!--          <CChartLineSimple-->
<!--            pointed-->
<!--            class="mt-3 mx-3"-->
<!--            style="height:70px"-->
<!--            :data-points="[65, 59, 84, 84, 51, 55, 40]"-->
<!--            point-hover-background-color="primary"-->
<!--            :label="$t('components.totalSales')"-->
<!--            labels="months"-->
<!--          />-->
        </template>
      </CWidgetDropdown>
    </CCol>

      <CCol col="2">
          <CWidgetDropdown
                  style="margin-bottom:0;height:80px;place-items: center;text-align: center"
                  class="box_item_center"
                  color="danger"
                  :header="get_currency(products)"
                  :text="$t('Costs2')"
          >
              <template #default>
              </template>
              <template #footer>

              </template>
          </CWidgetDropdown>
      </CCol>
      <CCol col="2">
          <CWidgetDropdown
                  style="margin-bottom:3px;height:80px;place-items: center;text-align: center"
                  class="box_item_center"
                  color="success"
                  :header="get_currency(customers)"
                  :text="$t('ProfitLoss')"
          >

              <template #default>

              </template>
              <template #footer>

              </template>
          </CWidgetDropdown>
      </CCol>

      <CCol col="2">
      <CWidgetDropdown
              style="margin-bottom:0;height:80px;place-items: center;text-align: center"
              class="box_item_center"
              color="warning" :header="get_currency(buys)" :text="$t('VAT')">
        <template #default>


        </template>
        <template #footer>

        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol col="2">
      <CWidgetDropdown
              style="margin-bottom:3px;height:80px;place-items: center;text-align: center"
              class="box_item_center"
        color="primary"
        :header="get_currency(payable)"
        :text="$t('AccountPayable')"
      >

        <template #default>

        </template>
        <template #footer>

        </template>
      </CWidgetDropdown>
    </CCol>
  </CRow>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from '../charts/index.js'
import {bus} from "../../main";

export default {
  name: 'WidgetsDropdown',
  components: { CChartLineSimple, CChartBarSimple },
  props: {
    sales: String,
    buys: String,
    customers: String,
    products: String,
    payable: String,
  },
  computed: {
    sales2: function() {
      return this.sales;
    },
  },methods:{

    }
}
</script>
<style>
    .box_item_center  .card-body{
        place-items: center;
    }
</style>
